export default "__VITE_ASSET__C7rg$Cjq__"